import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

export default defineNuxtPlugin((nuxtApp) => {
  // get the config
  const config = useRuntimeConfig()
  const { hiyieldNuxtLayerFirebase } = useAppConfig()
  const { initAuth, initFirestore, initStorage } = hiyieldNuxtLayerFirebase

  const settings = {
    apiKey: config.public.firebaseApiKey,
    appId: config.public.firebaseAppId,
    authDomain: config.public.firebaseAuthDomain,
    measurementId: config.public.firebaseMeasurementId,
    messagingSenderId: config.public.firebaseMessagingSenderId,
    projectId: config.public.firebaseProjectId,
    storageBucket: config.public.firebaseStorageBucket
  }

  for (const [key, value] of Object.entries(settings)) {
    const importantKeys = ['apiKey', 'appId', 'authDomain', 'projectId']
    if (importantKeys.includes(key) && !value) {
      console.error(`No ${key} found in runtimeConfig.public. Firebase will likely not work on the client.`)
    }
  }

  const app = initializeApp(settings)
  nuxtApp.provide('clientFirebaseApp', app)
  if (initAuth.client) nuxtApp.provide('clientFirebaseAuth', getAuth(app))
  if (initFirestore.client) nuxtApp.provide('clientFirebaseFirestore', getFirestore(app))
  if (initStorage.client) nuxtApp.provide('clientFirebaseStorage', getStorage(app))
})
